import type { ReactNode } from "react";

import { Stack, Typography } from "@braintrust/braintrust-ui-components";
import { CircleCheckIcon } from "@braintrust/braintrust-ui-components/Icons";

type InfoRowProps = { label: ReactNode };

export const InfoRow = ({ label }: InfoRowProps) => {
  return (
    <Stack
      direction="row"
      sx={{ alignItems: "center", justifyContent: "flex-start", gap: "13px" }}
    >
      <CircleCheckIcon sx={{ fontSize: "16px", color: "var(--positive-2)" }} />
      <Typography
        variant="paragraph"
        component="div"
        size="medium"
        sx={{ overflow: "hidden", overflowWrap: "anywhere" }}
      >
        {label}
      </Typography>
    </Stack>
  );
};
